import type { ClientContext } from '~/services/contextClient';
import type { ScheduledMessagesClientInterface } from './scheduledMessagesClient.types';
import CorporateScheduledMessagesClient from './corporateScheduledMessagesClient';
import GroupScheduledMessagesClient from './groupScheduledMessagesClient';

export default class ScheduledMessagesFactory {
    static createClient(context: ClientContext): ScheduledMessagesClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateScheduledMessagesClient(context.teamId);
        } else if (context.orgUnitId) {
            throw new Error('Organizational unit scheduled messages client not yet implemented');
        } else if (context.groupId) {
            return new GroupScheduledMessagesClient(context.teamId, context.groupId);
        }

        throw new Error('Invalid context');
    }
}
